import React from "react";
import Hero from "./Hero";
import StoresSlice from "./StoresSlice";

export default function Slices(props) {
  if (!document) {
    return null;
  }
  return (
    <div className="slice-wrapper">
      {props.slices.map((slice, index) => (
        <div key={index} className="slice-single">
          {slice.slice_type === "hero" && Hero(slice)}
          {slice.slice_type === "stores_slice" && StoresSlice(slice)}
        </div>
      ))}
    </div>
  );
}
